import React from "react";
import {SlArrowLeft,SlArrowRight} from 'react-icons/sl'
import "./carousel.css";

const Carousel = (Props) => {
  const { children,show } = Props;
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [length, setLength] = React.useState(children.length);
 
  //touch event
  const [touchPosition, setTouchPosition] = React.useState(null);
  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };
  const handleTouchMove = (e) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);
  };

  const next = () => {
    if (currentIndex < (length - show)) {
        setCurrentIndex(prevState => prevState + 1)
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  // Set the length to match current children from props
  React.useEffect(() => {
    setLength(children.length);
  }, [children]);
  return (
    <div className="carousel-container">
        <div className="carousel_control">
        {currentIndex > 0 && (
          <button onClick={prev} className="left-arrow">
            <SlArrowLeft/>
          </button>
        )}
        {currentIndex < (length - show) && (
          <button onClick={next} className="right-arrow">
            <SlArrowRight/>
          </button>
        )}
        </div>
      <div className="carousel-wrapper">
        <div
          className="carousel-content-wrapper"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
        >
          <div
          className={`carousel-content show-${show}`}
          style={{ transform: `translateX(-${currentIndex * (100 / show)}%)` }}
          >
            {children}
          </div>
        </div>
        
      </div>
    </div>
  );
};
export default Carousel;
